import declare from "dojo/_base/declare";
import SelectBOMItemProductForm from "../SelectBOMItemProductForm";

const SelectRecipeItemProductForm = declare([SelectBOMItemProductForm], {
    
});

export = SelectRecipeItemProductForm;